import { useMediaQuery, useTheme } from '@mui/material'

export const useResponsive = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return { isMobile, isTablet, isDesktop }
}
